module.exports = __webpack_public_path__ + "close-field.png?b25140acd56f70ec127f27d647201390";